import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useReveal } from '../../hooks/useReveal';
import { ArrowDown } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_ebfcb4ad-e78d-4e26-be19-6338bba630f2/artifacts/tgcpznjt_Nexa_Logo%20icon%20cyan%20.png';

const Hero = () => {
  const { t, isRTL } = useLanguage();
  const [ref, visible] = useReveal();

  return (
    <section id="hero" ref={ref} className="relative min-h-screen flex items-center bg-gradient-to-br from-[#0A1628] via-[#0E2240] to-[#0A1628] overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      <div className="absolute top-20 end-20 w-96 h-96 bg-[#00B4D8]/10 rounded-full blur-[120px]" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-32 w-full">
        <div className={`max-w-3xl transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 data-testid="hero-title" className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight">
            {t('hero.title')}
          </h1>
          <p className="mt-6 text-lg text-slate-300 leading-relaxed max-w-2xl">
            {t('hero.desc')}
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a href="#contact" data-testid="hero-cta-primary"
              className="inline-flex items-center gap-2 bg-[#00B4D8] hover:bg-[#0094B3] text-white font-semibold px-7 py-3.5 rounded-lg transition-colors text-sm">
              {t('hero.cta')}
            </a>
            <a href="/products" data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-2 border border-white/20 hover:border-[#00B4D8]/50 text-white font-medium px-7 py-3.5 rounded-lg transition-colors text-sm hover:bg-white/5">
              {t('hero.cta2')}
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown className="w-5 h-5 text-white/30" />
      </div>
    </section>
  );
};

export default Hero;
